import { render, staticRenderFns } from "./ListOfCurrentActivities.vue?vue&type=template&id=bf750c2c"
import script from "./ListOfCurrentActivities.vue?vue&type=script&lang=js"
export * from "./ListOfCurrentActivities.vue?vue&type=script&lang=js"
import style0 from "./ListOfCurrentActivities.vue?vue&type=style&index=0&id=bf750c2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports